// CustomerFrontEventManagment

import { User                                     , 
         initializedUser                          } from '../userManagment/types';
		 
import { DetailledIpAddressInformations           , 
         initializedDetailledIpAddressInformations} from '../networkManagment/types';

import { Video                                    ,
         initializedVideo                         } from '../mediaManagment/video_types';

import { Media                                    ,
         initializedMedia                         } from '../mediaManagment/types';


export interface CustomerFrontEvent {

  id                    : number      ,
  userId                : number      ,
  event                 : string      ,
  eventDate             : Date | null ,
  ipAddress             : string      ,
  userAgentInformations : string      ,
  appInformations       : string      ,
  
  country               : string      ,
  city                  : string      ,
  lat                   : number      ,
  lon                   : number      ,
  isp                   : string      ,
}

export const initializedCustomerFrontEvent = (): CustomerFrontEvent => ( 
 {
  id                    : 0    ,
  userId                : 0    ,
  event                 : ""   ,
  eventDate             : null ,
  ipAddress             : ""   ,
  userAgentInformations : ""   ,
  appInformations       : ""   ,
  
  country               : '',
  city                  : '',
  lat                   : 0,
  lon                   : 0,
  isp                   : ''
});

export interface EnrichedCustomerFrontEvent extends CustomerFrontEvent {
  user?         : User                           | null,
  ipDetails?    : DetailledIpAddressInformations | null,
  ipMismatch?   : boolean                        | null,
  videoDetails? : Video                          | null,
  mediaDetails? : Media                          | null
}

export const initializedEnrichedCustomerFrontEvent = (): EnrichedCustomerFrontEvent => ({
  ...initializedCustomerFrontEvent()                       ,
  user         : initializedUser()                           ,
  ipDetails    : initializedDetailledIpAddressInformations() ,
  ipMismatch   : false                                       ,
  videoDetails : initializedVideo(),
  mediaDetails : initializedMedia()
});


export interface GetSessionsParams {
  userEmail?     : string;
  userId?        : number; 
  ipAddress?     : string;
  beginningDate? : Date; 
  endingDate?    : Date;    
}


export interface GetCustomerFrontEventParams {
  userEmail?     : string;
  userId?        : number; 
  ipAddress?     : string;
  eventFragment? : string;
  beginningDate? : Date; 
  endingDate?    : Date;    
}

export interface UserSession {
  startDate             : Date;
  duration              : number;
  isDurationExact       : boolean;
  isFinished            : boolean;
  eventCount            : number;
  ipAddress             : string;
  ipAddressProviderName : string;
  ipAddressCity         : string;
  ipAddressCountry      : string;
  ipAddressLat          : number;
  ipAddressLon          : number;
  userId                : number;
  userEmail             : string;
  userFirstname         : string;
  userLastname          : string;
  userCreationIpAddress : string;
  ipMismatch            : boolean;
}

export interface LiveSession extends UserSession {
  channelId         : number; 
}

export interface VideoSegment {
  startTime : number;
  endTime   : number;
  duration  : number;
  event     : string;
}

export interface ReplaySession extends UserSession {
  videoId         : number; 
  videoTitle      : string;
  watchedSegments : VideoSegment[];
}

export interface SessionEvent {
  start     : Date   ;
  end       : Date | null ;
  ipAddress : string ;
  userId    : number ;
  elementId : number ;  
}

export interface SessionActivity {
  date     : Date   ;
  activity : number;
}

export interface UrlRedirectionEvent extends CustomerFrontEvent {
}